import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { Overlay } from "./Overlay.js";
import "./styles.css";

createRoot(document.getElementById("root")!).render(<StrictMode>{location.pathname === "/overlay" ? <Overlay /> : <App />}</StrictMode>);

